import { useEffect, useState, useCallback } from "react";
import axios from "axios";
export default function Api(url, params) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hacerSolicitud = useCallback( async () => {
    setLoading(true);
    setError(null);
    const header = {
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    };
    try {
      const responser = await axios.post(url, params, header);
      setData(responser.data);
      setLoading(false);
      document.getElementById('result').style.display = "inline";
      if (responser.data.length === 0) {
        if (document.getElementById('snippet_resul')) {
          document.getElementById('snippet_resul').style.display = "block";
        }
        if (document.getElementById("ResultadosTotales")) {
          document.getElementById('ResultadosTotales').style.display = "block";
        }
        if (document.getElementById("informacionEncontrados")) {
          document.getElementById('informacionEncontrados').style.display = "block";
        }
      }
      if (responser.data.length >= 0) {
        if (document.getElementById("ResultadosTotales")) {
          document.getElementById('ResultadosTotales').style.display = "block";
        }
        if (document.getElementById("informacionEncontrados")) {
          document.getElementById('informacionEncontrados').style.display = "block";
        }
      }
    } catch (error) {
      setError(error);
      console.error(error);
      setLoading(false);
    }
  },[url, params]);
  useEffect(() => {
    if (loading){
      hacerSolicitud();
    }
  }, []); 
  return {data, loading, error};
}